export default __webpack_public_path__ + "static/media/DashImage.e2d59a77.png";